import { Component, Input, OnInit } from '@angular/core';
import { InsightsService } from '../../../services/insights-service';

@Component({
  selector: 'app-insights-layout',
  templateUrl: './insights-layout.component.html',
  styleUrls: ['./insights-layout.component.scss'],
  standalone: false
})
export class InsightsLayoutComponent implements OnInit {
  @Input() isLoggedIn: boolean = false;
  @Input() isInsightsLandingPage: boolean = false;

  constructor(private insightsService: InsightsService) {}

  ngOnInit() {
    this.isInsightsLandingPage = this.insightsService.isInsightsDomain() && window.location.pathname === '/';
  }
}

